module.exports = __webpack_public_path__ + "img/electronic_enabled_selected.8955de81.svg";